import {computed, ref} from "@vue/reactivity";

const buttonBlocked = ref(0);
const isBlocked = computed(() => buttonBlocked.value > 0);
const blockButton = () => buttonBlocked.value++;
const unblockButton = () => buttonBlocked.value--;

export {
    isBlocked,
    blockButton,
    unblockButton
}